module.exports = __webpack_public_path__ + "static/defaultimagefr-d95bafb0eb4a193bb0c12dfbdc33f1d0.png";